const icon = new URL('../../icons/tank.png', import.meta.url).href

export default {
  type: 'tank',
  description: 'Tank',
  group: '3D' /* line|shape|textAndMedia|chartAndGauge|table|container|dataSource|IoT|3D|warehouse|form|etc */,
  icon,
  model: {
    type: 'tank',
    left: 100,
    top: 100,
    width: 80,
    height: 120,
    depth: 100,
    fillStyle: '#aaaaaa',
    strokeStyle: '#999',
    lineWidth: 1,
    alpha: 1,
    value: 50,
    liquidColor: 'red'
  }
}
